export const UPDATE_ACTIVE_QUERY = 'UPDATE_ACTIVE_QUERY';

export function updateActiveQuery(payload) {
    return {
        type: UPDATE_ACTIVE_QUERY,
        payload,
    };
}
